'use strict';

var _ = require('lodash');
var d3 = require('d3');
var ScalesFactory = function ScalesFactory() {
  var Scales = function Scales(params, data, range, metricKey, complementalMetricKey) {
    /**
     * In case when there's no d.m3 or d.m4 use zero (ex. postDepartureMode)
     * @param d
     * @returns {Array}
     */
    var yMin = d3.min(data, function (d) {
      var complementalValue = d[complementalMetricKey] || 0;
      return Math.min(0, d[metricKey], complementalValue);
    });
    var yMax = d3.max(data, function (d) {
      var complementalValue = d[complementalMetricKey] || 0;
      return Math.max(0, d[metricKey], complementalValue);
    });
    yMax = considerAmountOfTicks(params, yMin, yMax);

    // the brush can modify the visible range of elements
    data = data.slice(range[0], range[1]);
    var x = d3.scale.ordinal().domain(_.map(data, 'runNumber')).rangeBands([0, params.width], 0.1, 0.05);
    var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]).nice();
    return {
      xScale: x,
      yScale: y
    };
  };
  function considerAmountOfTicks(params, yMin, yMax) {
    return _.max([yMax, yMin + params.yNumberOfTicks]);
  }
  return Scales;
};
ScalesFactory.$inject = ['SnapshotDatesMapDataToChartComponentsService'];
module.exports = ScalesFactory;